import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcRequirementType } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcRequirementTypeList,

    LoadCcRequirementTypes,
    SortCcRequirementTypes,
    DeleteCcRequirementType,

    setCcRequirementTypeList,
    setCcRequirementTypeIds,
    setCcRequirementTypeSort,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    SortRows,
    DeleteRow,
} from "client/components"

import Columns from "./columns"
import Edit from "./edit"

const Type = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const typeList = useSelector((state: StoreType) => state.ccRequirementType.typeList)
    const typeIds = useSelector((state: StoreType) => state.ccRequirementType.typeIds)
    const sortColumn = useSelector((state: StoreType) => state.ccRequirementType.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.ccRequirementType.sortOrder)
    const filters = useSelector((state: StoreType) => state.ccRequirementType.filters)
    const reloadList = useSelector((state: StoreType) => state.ccRequirementType.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultRequirementsTypeAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadCcRequirementTypes(userData.accountId, project.id).then((res) => {
            dispatch(setCcRequirementTypeList(res))
            setLoadState(IDLE)
        })
    }, [reloadList, project, defaultRequirementsTypeAssigned])

    useEffect(() => {
        const sortedIds = SortCcRequirementTypes(Object.values(typeList), sortColumn, sortOrder, filters)
        dispatch(setCcRequirementTypeIds(sortedIds))
    }, [typeList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof CcRequirementType, order) => {
        dispatch(setCcRequirementTypeSort(column, order))
    }

    const onDelete: DeleteRow = (type: CcRequirementType, callback) => {
        DeleteCcRequirementType(type.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const typeListCopy: CcRequirementTypeList = typeList ? deepCopy(typeList) : {}
                delete typeListCopy[type.id]
                dispatch(setCcRequirementTypeList(typeListCopy))
                dispatch(setCcRequirementTypeIds(typeIds.filter((id) => id !== type.id)))
            })
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={typeList}
                dataIds={typeIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="sm"
                showPagination
                onSort={onSort}
                onDelete={onDelete}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addType",
                            content: <Edit typeId={0} editAccess={editAccess} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default Type
